module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-thin-rounded-HOOVQNVT.woff2?3dce97ba056be622d4ddb41485a11632";